<div class="lid-alert-popover">
  <ng-container *ngIf="loading">
    <ul class="loader">
      <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7]">
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </ng-container>

  <app-line-item-delta-alert
    *ngIf="!loading && !isError"
    [showSubscription]="true"
    [data]="lidAlertData"
    (lidAlertDataChanged)="onLidAlertChange($event)"
  ></app-line-item-delta-alert>

  <div class="save-btn-wrapper" *ngIf="!isError">
    <button
      class="save-btn"
      nz-button
      nzType="primary"
      [disabled]="disabledSaveButton"
      (click)="onClickSave()"
    >
      Save
    </button>
  </div>
  <div *ngIf="!loading && isError"
    class="error"
  >
    <va-icon name="exclamation-triangle" size="small" class="info-icon"></va-icon>
    <span class="error-text">Sorry, something went wrong.</span>
  </div>
</div>
